import styled from "styled-components";

export const Container = styled.div`
  width: 65%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  background-color: ${({ outlineColor }) => outlineColor};
  position: relative;
`;

export const Boxheader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 3.5vw;
  padding: 0 1.125rem;
`;

export const TitleComp = styled.div`
  display: flex;
  align-items: center;
  gap: 0.938rem;
  position: relative;
`;

export const Box = styled.div`
  flex: 1;
  background-color: #ffffff;
  padding: 0 1.25rem;
`;

export const Title = styled.h1`
  margin: 0px;
  font-size: 1.125rem;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  line-height: 1.361rem;
  text-align: left;
  color: #606080;
  text-transform: uppercase;
`;
